var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEiCustomToolResetAxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H7M7 7V3M7 7L1 1M3 13H7M7 13V17M7 13L1 19M17 7H13M13 7V3M13 7L19 1M17 13H13M13 13V17M13 13L19 19",
    fill: "var(--primaryA2)",
    stroke: "var(--primaryA1)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiCustomToolResetAxes);
export default __webpack_public_path__ + "static/media/EICustomToolResetAxes.05f8509c81fe805cf502fd99fd431342.svg";
export { ForwardRef as ReactComponent };